import { useState } from 'react';

function documentScrolls() {
  if (typeof document === 'undefined') {
    return false;
  }

  const {
    scrollHeight,
    clientHeight,
    scrollWidth,
    clientWidth,
  } = document.documentElement;

  return scrollHeight > clientHeight || scrollWidth > clientWidth;
}

/**
 * For react-remove-scroll's `removeScrollBar`: its lock restyles `<body>`,
 * which makes the browser restyle and lay out the whole page. A page with no
 * scrollbar has nothing to lock, so an overlay can skip that cost.
 */
export function useDocumentScrollsOnMount() {
  const [scrolls] = useState(documentScrolls);

  return scrolls;
}
